import { ErrorCandidate } from './extractors';

export function prepareUnhandledError(error: PromiseRejectionEvent): ErrorCandidate | undefined {
  try {
    return error.reason;
  } catch (err) {
    return undefined;
  }
}
